import {AnyHash, ModelInterface, uString, Uuid} from "@hidat/huijs-common";
import {HasTenantResource, RailsUpdateTrackingResource, ResourceConfig} from "@hidat/huijs-resource";

export const UserSettingConfig: ResourceConfig =
  new ResourceConfig('UserSetting', 'user_settings', true, true)

// Page settings, currently only used for grids
export interface PageSettingInterface {
  grid?: AnyHash;   // viewId: columns []
}

// Last process media settings
export interface ProcessMediaSettingInterface {
  file_format?: number;
  name_format?: string;
  location?: string;
}

// Type of resource is designated in the UserSetting key
export interface RecentlyUsedItemSettingInterface {
  _name?: string;
  item_id?: number;
  last_used?: string;  //Date
}
export interface RecentlyUsedSettingInterface {
  items?: RecentlyUsedItemSettingInterface [];
}

export type UserSettingsKlassTypes =
  "Page" | "Recent" | "ProcessMedia" ;

export interface UserSettingInterface extends ModelInterface, RailsUpdateTrackingResource, HasTenantResource {
  id: number | undefined;
  userId: Uuid | undefined;
  appCode: string | undefined;
  key: uString;
  settingsKlass: UserSettingsKlassTypes | undefined;
  settingsExtended: AnyHash | PageSettingInterface | ProcessMediaSettingInterface | RecentlyUsedSettingInterface | undefined;
}
